import * as yup from 'yup';

export const scorerDetailsSchema = yup.object({
  yearsOfExperience: yup
    .string()
    .trim()
    .required('Years of experience is required')
    .matches(/^\d+$/, 'Please enter a valid number'),
  matchesFormatWorkedOn: yup
    .string()
    .required('Matches format is required')
    .test('not-empty', 'Please select matches format', (v) => !!v && v !== ''),
  familiarScoringMethod: yup
    .string()
    .required('Familiar scoring method is required')
    .test('not-empty', 'Please select scoring method', (v) => !!v && v !== ''),
  pricingPerMatch: yup
    .string()
    .trim()
    .required('Pricing per match is required')
    .matches(/^\d+(\.\d+)?$/, 'Please enter a valid amount'),
  scoringInterfacePreference: yup
    .string()
    .required('Scoring interface preference is required')
    .test('not-empty', 'Please select interface', (v) => !!v && v !== ''),
  preferredCity: yup.string().trim().required('Preferred city is required'),
  pricingPerDay: yup
    .string()
    .trim()
    .required('Pricing per day is required')
    .matches(/^\d+(\.\d+)?$/, 'Please enter a valid amount'),
  languageKnown: yup
    .string()
    .required('Language is required')
    .test('not-empty', 'Please select language', (v) => !!v && v !== ''),
});

export type ScorerDetailsFormValues = yup.InferType<typeof scorerDetailsSchema>;
